import { CelebrityRole, Contribution, PlayBaseWithVideo } from 'typings/api';
import { Celebrity as APICelebrity } from 'typings/api/celebrity';
import { slugifyString, twoLetterShortName, unifyArray } from 'helpers';
import { defaultLocale } from 'i18n';

class Celebrity implements APICelebrity {
  about?: string;
  contributions?: Array<Contribution>;
  id: number;
  name: string;
  /**
   * Url slug for SEO
   */
  slug: string;
  poster_url?: string;
  kinobox: 12434;
  names: {
    language: string;
    value: string;
  }[];

  get shortName(): string {
    return twoLetterShortName(this.name);
  }

  get flattenedContributions(): CelebrityRole[] {
    return unifyArray(this.contributions.map((contribution) => contribution.roles).flat());
  }

  playsForRole(role: string): PlayBaseWithVideo[] {
    return this.contributions
      .map((cont) => ((cont.roles as unknown as string).indexOf(role) > -1 ? cont.play : null))
      .filter((x) => !!x);
  }

  public localisedSlug(locale: string): string {
    return slugifyString(
      this.names?.find((n) => n.language === locale)?.value ??
        this.names?.find((n) => n.language === defaultLocale).value ??
        this.name,
    );
  }

  static fromJSON(json: Partial<APICelebrity>): Celebrity {
    return Object.assign(new Celebrity(), json);
  }
}

export default Celebrity;
